import { httpClient, HttpMethod } from './http-client';
import { Timezone } from '../@types/timezone.type';

export const getTimezones = (): Promise<Timezone[]> => {
  return httpClient<Timezone[]>('/timezones', HttpMethod.Get);
};
